module.exports = __webpack_public_path__ + "img/device_hatsu.ac3f651a.png";